import { Validation } from "../../../utils/Validation/Validation";
import { SignatureModal } from "../SignatureModal/SignatureModal";

/**
 * Modal that handles annulating documents
 * @param {{
 *  onCloseModal : () => void
 *  isModalMessage : string,
 *  onSend : (reason : string, body : *) => void,
 * }} props
 * @returns {import("react").ReactNode}
 */

export function AnnulateModal({ onSend, ...props }) {
  const isDescriptionProblem = Validation();

  return (
    <SignatureModal
      {...props}
      description="Annulate document"
      onSend={(body) => onSend(isDescriptionProblem.value, body)}
    >
      <div className="annulate-modal-input-block">
        <label className="annulate-modal-input-block__label">
          Specify the reason for canceling the document
        </label>
        <textarea
          className="annulate-modal-input-block__input"
          value={isDescriptionProblem.value}
          onChange={isDescriptionProblem.onChange}
        />
      </div>
    </SignatureModal>
  );
}
